"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrieNodeKind = void 0;
var TrieNodeKind;
(function (TrieNodeKind) {
    TrieNodeKind["ROOT"] = "root";
    TrieNodeKind["DYNAMIC"] = "dynamic";
    TrieNodeKind["QUERY"] = "query";
    TrieNodeKind["BOOLEAN"] = "boolean";
    TrieNodeKind["STATIC"] = "static";
})(TrieNodeKind = exports.TrieNodeKind || (exports.TrieNodeKind = {}));
